import {sendRequest} from "./tools/ajax_es";

export function init()
{
    // inicializace eventu
    const branches = document.getElementsByClassName('branches');

    for (var i = 0; i < branches.length; i++)
    {
        let branch = branches[i];
        let tooltip = branch.getElementsByClassName('tooltip');
        let content = branch.getElementsByClassName('content');

        if(content.length > 0)
        {
            content = content[0];
        }

        if(content && tooltip.length > 0)
        {
            tooltip = tooltip[0];

            if (!tooltip.onclick)
            {
                tooltip.onclick = () => { hideBranches(branches); branchLoading(tooltip, content); };
            }
        }

    }
}

export function branchLoading(tooltip, content, urlAjax)
{
    if(!urlAjax)
    {
        urlAjax = prepareAjaxUrl(content, 1);
    }

    sendRequest(urlAjax, function (xmlhttp) {

        handleResponse(xmlhttp, content);

        const closeButton = content.getElementsByClassName("close-it");

        if(closeButton.length > 0)
        {
            closeButton[0].addEventListener('click', () => { resetBanches(content) });
        }

        let nextButton = content.getElementsByClassName("next-button");
        let prevButton = content.getElementsByClassName("prev-button");

        if(nextButton.length > 0)
        {
            nextButton = nextButton[0];
            nextButton.addEventListener('click', () => { if(nextButton.getAttribute('data-click') == 0) return; showButton(prevButton); lazyLoading(nextButton, content, 1, 1); });
        }

        if(prevButton.length > 0)
        {
            prevButton = prevButton[0];
            showButton(prevButton, true);
            prevButton.addEventListener('click', () => { if(prevButton.getAttribute('data-click') == 0) return; showButton(nextButton); lazyLoading(prevButton, content, -1, 1); });
        }
    }, () => { resetBanches(content); });
}

function lazyLoading(button, content, pageDiff, dataShow)
{
    let listContent = content.getElementsByClassName('text-left');

    if(listContent.length === 0)
    {
        return;
    }
    listContent = listContent[0];

    let urlAjax = prepareAjaxUrl(content, pageDiff, dataShow);

    sendRequest(urlAjax, function (xmlhttp) {

        handleResponse(xmlhttp, listContent);

        let endDetail = listContent.getElementsByClassName("end-detail");
        let initPage = parseInt(content.getAttribute('data-init'));
        let page = parseInt(content.getAttribute('data-page'));

        if(endDetail.length > 0 || initPage == page)
        {
            showButton(button, true);
        }
    });
}

function prepareAjaxUrl(content, pageDiff, dataShow)
{
    let page = parseInt(content.getAttribute('data-page'));
    page += pageDiff;
    content.setAttribute('data-page', page);

    let initPage = parseInt(content.getAttribute('data-init'));

    if(!(initPage >= 0))
    {
        content.setAttribute('data-init', page);
    }

    let urlAjax = content.getAttribute('data-link');
    urlAjax = urlAjax.replace(/-page=\d+/, "-page=" + page);
    // z nette to prijde mrdly, tak to osetrim tady
    urlAjax = urlAjax.replace(/&amp;/g, "&");

    if(dataShow)
    {
        urlAjax = urlAjax.replace(/ignoreShow=\d+/, "ignoreShow=1");
    }

    return urlAjax;
}

function handleResponse(xmlhttp, content)
{
    const snippetResponse = xmlhttp.response;
    const snippets = snippetResponse.snippets;

    for (var i in snippets)
    {
        const leaflets = snippets[i];
        content.innerHTML = leaflets;
        break;
    }
}

export function hideBranches(branches)
{
    if(!branches)
    {
        branches = document.getElementsByClassName('branches');
    }
    for (var i = 0; i < branches.length; i++)
    {
        let branch = branches[i];
        let content = branch.getElementsByClassName('content');

        if(content.length > 0)
        {
            content = content[0];
            resetBanches(content);
        }
    }
}

// kvuli amp a dalsimu nacteni letaku to musim mazat (nestaci skryt)
function resetBanches(content)
{
    if(content.innerHTML)
    {
        content.innerHTML = "";
        const defaultPage = content.getAttribute('data-page-default');
        content.setAttribute('data-page', defaultPage ? defaultPage : 0);
    }
}

function showButton(button, hidden)
{
    if(hidden)
    {
        button.style.backgroundColor = '#e1e1e1';
        button.getElementsByClassName('page-arrow')[0].style.borderColor = 'gray';
        button.setAttribute('data-click', 0)
    }
    else
    {
        button.style.backgroundColor = '#d9217d';
        button.getElementsByClassName('page-arrow')[0].style.borderColor = 'white';
        button.setAttribute('data-click', 1)
    }
}








